export class ProductInvGridConfigModel {

    Id: number;
    OwnerCode: string;
    UserId: string;
    CustomerProductCodeActive: boolean = true;
    CustomerProductDescriptionActive: boolean = true;
    VintageActive: boolean = true;
    FormatActive: boolean = true;
    AlcoholStrengthActive: boolean = true;
    DutyStatusActive: boolean = true;
    AvailQtyActive: boolean = true;
    UomActive: boolean = true;
    CasingQuantityActive: boolean = true;
    CasingTypeActive: boolean = true;
    ConditionActive: boolean = true;
    CountryActive: boolean = true;
    LotsActive: boolean = true;
    LwinActive: boolean = true;
    DescriptionActive: boolean = true;
    ProductTypeActive: boolean = true;
    ProductSubTypeActive: boolean = true;
    ColourActive: boolean = true;
    RegionActive: boolean = true;
    SubRegionActive: boolean = true;
    ProducerActive: boolean = true;
    ClassificationActive: boolean = true;
    PriceActive: boolean = true;
    CurrencyActive: boolean = true;
    ExpiryDateActive: boolean = true;
    CustodianActive: boolean = true;
    RemarksActive: boolean = true;
    GrnNoActive: boolean = true;
    GrnDateActive: boolean = true;
    StorageCategoryActive: boolean = true;

    CreatedBy: string;
    UpdatedBy: string;
}



// WEBPACK FOOTER //
// ./src/app/data/models/master/op/product-inv-grid-config.model.ts